import { render, staticRenderFns } from "./ysgDetail.vue?vue&type=template&id=38e3ce66"
import script from "./ysgDetail.vue?vue&type=script&lang=script"
export * from "./ysgDetail.vue?vue&type=script&lang=script"
import style0 from "./ysgDetail.vue?vue&type=style&index=0&id=38e3ce66&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports